import { ITipoModalidade } from '../disciplina';

export const TipoModalidade = {
  presencial: 'Presencial' as ITipoModalidade,
  split: 'Split' as ITipoModalidade,
  ead: 'EAD' as ITipoModalidade,
};
